import { CONTRACT_PROGRESS_TRACKER_WITHIN_BOUNDARIES } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressTrackerWithinBoundariesState = boolean;

const initialState: ContractProgressTrackerWithinBoundariesState = false;

export default function reducer(
  state: ContractProgressTrackerWithinBoundariesState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_TRACKER_WITHIN_BOUNDARIES:
      return action.payload;
    default:
      return state;
  }
}
